import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.10 + 15.11 Ce se întâmplă într-o ședință + apel gratuit ── */
export function HomeSession() {
  const c = useSectionContent("home_session");
  const cards = [
    { t: "Nu trebuie să știi ce să spui", d: "Vin eu spre tine. Poți și să taci — și tăcerea spune multe.", tf: "card1_title", df: "card1_body" },
    { t: "Rămâne între noi", d: "Complet confidențial. Nimic din ce împarți nu iese din cameră.", tf: "card2_title", df: "card2_body" },
    { t: "Mergem în ritmul tău", d: "Fără grabă, fără presiune. Cât poți duce azi, atât.", tf: "card3_title", df: "card3_body" },
  ];
  return (
    <section className="py-16 lg:py-20" style={{ background: "var(--ct-bg)" }}>
      <div className="max-w-4xl mx-auto px-5">
        <div className="text-center mb-10">
          <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Fără necunoscut, fără frică"}</span>
          <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mt-3">{c.title || "Cum e, de fapt, o ședință cu mine"}</h2>
        </div>
        <div className="grid sm:grid-cols-3 gap-5 mb-10">
          {cards.map((card) => (
            <div key={card.tf} className="card-premium p-6">
              <HeartHandshake size={22} className="mb-3" style={{ color: "var(--ct-gold)" }} />
              <h3 data-el="item_title" data-field={card.tf} className="font-serif text-lg mb-1">{c[card.tf] || card.t}</h3>
              <p data-el="item_body" data-field={card.df} className="text-sm" style={{ color: "var(--ct-text-muted)" }}>{c[card.df] || card.d}</p>
            </div>
          ))}
        </div>
        <div className="text-center card-premium p-8" style={{ borderColor: "var(--ct-gold)" }}>
          <h3 data-el="item_title" data-field="call_title" className="font-serif text-2xl mb-2">{c.call_title || "Hai să ne cunoaștem întâi"}</h3>
          <p data-el="item_body" data-field="call_body" className="text-sm max-w-md mx-auto mb-5" style={{ color: "var(--ct-text-muted)" }}>
            {c.call_body || "Un apel scurt de cunoaștere, ca să vedem dacă rezonăm. Fără obligații — doar o discuție."}
          </p>
          <Link data-el="cta" data-field="cta" to="/programare" className="btn-gold" data-testid="home-session-cta">{c.cta || "Programează un apel de cunoaștere"} <ArrowRight size={15} /></Link>
        </div>
      </div>
    </section>
  );
}
